import { OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/popupTemplates";
const defaultQuery = { orderBy: "id desc" };

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, ...defaultQuery });
    return request(`${resource}/getlist${query}`, { method: "GET" }, { countInHeaders: true });
};
const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));
const getItem = ({ id }: { id: number }) => request(`${resource}/get/${id}`, { method: "GET" });
const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));

export { apply, index, getItem, delItem };
